import './SendButton.scss';
import * as React from 'react';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Link } from 'office-ui-fabric-react/lib/Link';
import {
    ISharingInformation, ISharingLinkSettings, AccessStatus, SharingAudience
} from '../../interfaces/SharingInterfaces';
import { IPerson } from '@ms/odsp-datasources/lib/PeoplePicker';
import SendButtonType from './SendButtonType';
import { getEncodedMessageLength, isLoadingData } from '../../utilities/ShareHelper';
import * as PropTypes from 'prop-types';
import PlatformDetection from '@ms/odsp-utilities/lib/browser/PlatformDetection';

export interface ISendButtonProps {
    ctaLabel?: string;
    currentSettings: ISharingLinkSettings;
    errorMessage: JSX.Element;
    linkRecipients: Array<IPerson>;
    maximumMessageLength: number;
    maximumSubjectLength?: number;
    messageText: string;
    subjectText?: string;
    onSendLinkClicked: (message: string, subject?: string) => void;
    permissionsMap: { [index: string]: AccessStatus };
    sendButtonType: SendButtonType;
    sharingInformation: ISharingInformation;
}

export default class SendButton extends React.Component<ISendButtonProps> {
    private _platformDetection: PlatformDetection;

    static contextTypes = {
        platformDetection: PropTypes.object.isRequired
    };

    constructor(props: any, context: any) {
        super(props);

        this._platformDetection = context.platformDetection;
    }

    public render(): React.ReactElement<{}> {
        /**
         * Checks permissionMap for any undefined values, meaning that there's currently
         * a pending API call determining if a user has permission or not.
         */
        let checkingPermissions = false;
        if (this.props.currentSettings.audience === SharingAudience.existing) {
            for (const recipient of this.props.linkRecipients) {
                if (this.props.permissionsMap[recipient.email] === undefined &&
                    this.props.permissionsMap[recipient.userId] === undefined) {
                    checkingPermissions = true;
                    break;
                }
            }
        }

        if (this.props.ctaLabel) {
            const isDisabled = !!this.props.errorMessage || isLoadingData(this.props.sharingInformation)
                || checkingPermissions || getEncodedMessageLength(this.props.messageText) > this.props.maximumMessageLength
                || getEncodedMessageLength(this.props.subjectText) > this.props.maximumSubjectLength;

            if (this.props.sendButtonType === SendButtonType.button) {
                return (
                    <PrimaryButton disabled={ isDisabled } onClick={ this._onSendLinkClicked }>{ this.props.ctaLabel }</PrimaryButton>
                );
            } else if (this.props.sendButtonType === SendButtonType.link) {
                return (
                    <div className='od-SendButton-linkButton'>
                        <Link disabled={ isDisabled } onClick={ this._onSendLinkClicked }>
                            { this._platformDetection.isAndroid ? this.props.ctaLabel.toUpperCase() : this.props.ctaLabel }
                        </Link>
                    </div>
                );
            }
        }
    }

    @autobind
    private _onSendLinkClicked(): void {
        this.props.onSendLinkClicked(this.props.messageText, this.props.subjectText);
    }
}